module.exports = __webpack_public_path__ + "img/brand-04.4528d6e8.png";